var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"gameImg"}},[_c('div',{staticClass:"game"},[_c('img',{attrs:{"src":_vm.game.gameImg,"alt":""}}),_c('div',{staticClass:"gameName",style:(_vm.gameNameBg)},[_vm._v(_vm._s(_vm.game.gameName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }